import Vue from 'vue';
import VueX from 'vuex';
import app from './module/app';
import successLeads from './module/successLeads';
import failedLeads from './module/failedLeads';
import users from './module/users';
import permissions from './module/permissions';
import cron from './module/cron.js';
import search from './module/search';
import leadLogs from './module/leadEditLogs';
import junkLeads from './module/junkLeads';
Vue.use(VueX)

export default new VueX.Store({
	modules: {
		app,
		failedLeads,
		successLeads,
		users,
		permissions,
		cron,
		search,
		leadLogs,
		junkLeads
	},
})


// WEBPACK FOOTER //
// ./src/store/index.js